import { API_URL } from "../../constants";
import * as httpNetworking from "../../httpNetworking";
import { SaasAppListItem } from "../../dashboard/saas/types";

const URL = API_URL + "/saas/app";
const VERSION = 1;

export const mockApiKey = () => `${new Date().getTime().toString(16)}${(Math.random() * 10000).toString(16)}`;

export const mockDevApiKeysResponse = [mockApiKey(), mockApiKey(), mockApiKey(), mockApiKey()];

export const mockProdApiKeysResponse = [mockApiKey(), mockApiKey(), mockApiKey(), mockApiKey()];

export let mockResponse: SaasAppListItem | undefined;

export let isRecreatingApp = false;

export const setIsRecreating = (isRecreating: boolean) => {
    isRecreatingApp = isRecreating;
};

export async function createSaasApp(data: any) {
    const options: httpNetworking.GETRequestConfig = {
        timeout: 60000
    };

    const result = await httpNetworking.simplePOSTRequest(URL, data, options, VERSION);
    return result.data as {};
}

// Used to fetch MAUs for deployments
export async function getAppMAUCount(appId: string, deploymentId: string, days: number = 30) {
    const options: httpNetworking.GETRequestConfig = {
        params: {
            deploymentId,
            days
        }
    };
    const url = `${API_URL}/saas/${appId}/deployment/users/active`;

    const result = await httpNetworking.simpleGETRequest(url, options, VERSION);
    return result.data;
}

// Used to fetch total number of users for deployments
export async function getTotalUsersInDbCount(appId: string, deploymentId: string) {
    const options: httpNetworking.GETRequestConfig = {
        params: {
            deploymentId
        }
    };
    const url = `${API_URL}/saas/${appId}/deployment/users/count`;

    const result = await httpNetworking.simpleGETRequest(url, options, VERSION);
    return result.data;
}
